import React, { useEffect, useRef, useState } from 'react';
import '../style/price.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Typography } from "@mui/material";
import '@mui/icons-material';
import $ from 'jquery'; // Import jQuery
import icon1 from '../images/satisfactionicon-02.svg';
import icon2 from '../images/garantuere.svg';
import icon3 from '../images/teamcompany.svg';
import icon4 from '../images/vacuumcleaner-.svg';

function Price() {
  const happyClient =[
    {
      title:'Zufriedene Kunden',
      images:icon1,
      icon:"+",
      number: '1500'
    },
    {
      title:'Servicegarantie',
      images:icon2,
      icon:"%",
      number: '100'
    },
    {
      title:'Reinigerinnen',
      images:icon3,
      icon:"+",
      number: '30'
    },
    {
      title:'Reinigung Abgeschlossen',
      images:icon4,
      icon:"+",
      number: '1000'
    },
  ];

  const counterRef = useRef(null); // Ref for counter element
  const [counted, setCounted] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const oTop = counterRef.current.offsetTop - window.innerHeight;
      if (counted === 0 && window.scrollY > oTop) {
        $('.count').each(function() {
          const $this = $(this);
          const countTo = $this.attr('data-count');
          $({
            countNum: $this.text()
          }).animate({
            countNum: countTo
          }, {
            duration: 2000,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum));
            },
            complete: function() {
              $this.text(this.countNum);
            }
          });
        });
        setCounted(1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [counted]);

  return (
    <div className='content-price'>
      {happyClient.map((happyClientService, index) => (
        <div className='content-happy-client' key={index}>
          <div className='first-div-happy div-images-happy' ref={counterRef}>
            <div className='box-img-happy'>
              <LazyLoadImage className='images-happy-laz' src={happyClientService.images} />
            </div>
            <Typography variant='h4' className='happy-tittle-client count' data-count={happyClientService.number}>
              {happyClientService.number}  <span className='material-icons'>{happyClientService.icon}</span>
            </Typography>
            <Typography variant='h6' className='happy-subttile-client'>
              {happyClientService.title}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Price;
